import React from "react";

import { LookupOrdersButton } from "../../../../../../../common/components/lookup-buttons/LookupOrdersButton";
import { useAssociateLookupOrders } from "../../../../../../common/content/buttons/lookups/lookup-orders/useAssociateLookupOrders";
import { useCloudFileAssociationSection } from "../../context/useCloudFileAssociationSection";
import { CloudFileAssociationTab } from "../../tabs/CloudFileAssociationTab";

export const CloudFileLookupOrdersButton = (): JSX.Element => {
    const { currentTab } = useCloudFileAssociationSection();
    const { setContentFromLookupOrders } = useAssociateLookupOrders();

    if (currentTab !== CloudFileAssociationTab.Associate) return <></>;

    return <LookupOrdersButton setContentFromLookupOrders={setContentFromLookupOrders} />;
};
